export const microsite = 'microsite'
export const project = process.env.REACT_APP_PROJECT_NAME
